import { useCallback } from 'react';
import { useGetFavorites } from 'api/favorites/use-get-favorites';
import { addMarker } from 'shared/utils/maps/add-marker.ts';
import { addPolyline } from 'shared/utils/maps/add-polyline.ts';
import type { IGetMarketsParams, IUseSetCargosMarkersOptions } from 'components/map/map-container/hooks/types.ts';
import { useCreateMarkerArray } from 'components/map/map-container/hooks/use-create-marker-array';
import { useSetMarkers } from 'components/map/map-container/hooks/use-set-markers.ts';

export const useSetCargosMarkers = ({
  map,
  cargos,
  setMode,
  handleClickShowBtn,
  costView,
}: IUseSetCargosMarkersOptions) => {
  const markerPayloads = useCreateMarkerArray(cargos || [], setMode);

  const { data: favorite } = useGetFavorites();

  const getMarkers = useCallback(
    ({ markersRef, polyLinesRef }: IGetMarketsParams) => {
      if (!map || !cargos) {
        return;
      }

      markerPayloads.forEach((markerPayload) => {
        const marker = addMarker({
          type: markerPayload.type,
          map,
          position: markerPayload.position,
          title: markerPayload.title,
          onClick: () => handleClickShowBtn?.(markerPayload.cargoId),
          favorites: favorite?.favoriteRecords?.[markerPayload.cargoId],
          costValue: markerPayload.costValue,
          costView,
        });
        markersRef.current.push(marker);

        if (markerPayload.isChangedPosition) {
          const polyline = addPolyline({
            map,
            path: [markerPayload.position, markerPayload.realPosition],
          });
          polyLinesRef.current.push(polyline);
        }
      });
    },
    [map, markerPayloads, costView],
  );

  useSetMarkers({ map, getMarkers, withCluster: true });
};
